import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import LogoText from "./LogoText";

export default function Header({ minimal = false }) {
  const { t } = useTranslation();
  return (
    <header className="w-full bg-white/95 backdrop-blur-md sticky top-0 z-50 border-b border-[#F0F2F5]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between gap-6">
        <Link to="/" className="flex flex-col leading-none" data-testid="brand-link">
          <LogoText size="md" />
          <span className="text-[10px] uppercase tracking-[0.18em] text-[#52606E] mt-1 font-medium">{t("ds.tagline_short")}</span>
        </Link>
        <div className="flex items-center gap-2 md:gap-5">
          {!minimal && (
            <nav className="hidden lg:flex items-center gap-6 text-sm text-[#52606E] font-medium">
              <Link to="/hoe-werkt-het" data-testid="nav-how">{t("ds.nav.how")}</Link>
              <Link to="/diensten" data-testid="nav-services">{t("ds.nav.services")}</Link>
              <Link to="/over-ons" data-testid="nav-about">{t("ds.nav.about")}</Link>
              <Link to="/kennisbank" data-testid="nav-knowledge">{t("ds.nav.knowledge")}</Link>
              <Link to="/voor-installateurs" data-testid="nav-partners">{t("ds.nav.partners")}</Link>
            </nav>
          )}
          <LanguageSwitcher />
          {!minimal && (
            <a href="/#zonnecheck" data-testid="nav-cta"
              className="hidden sm:inline-flex bg-[#F5C24C] hover:bg-[#E5AE2F] text-[#0B1B2B] font-medium rounded-full px-5 py-2.5 text-sm transition-all">
              {t("ds.hero.cta_primary")}
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
